import { render, staticRenderFns } from "./color.vue?vue&type=template&id=c1677c36&scoped=true&lang=pug&"
import script from "./color.vue?vue&type=script&lang=js&"
export * from "./color.vue?vue&type=script&lang=js&"
import style0 from "./color.vue?vue&type=style&index=0&id=c1677c36&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1677c36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('c1677c36', component.options)
    } else {
      api.reload('c1677c36', component.options)
    }
    module.hot.accept("./color.vue?vue&type=template&id=c1677c36&scoped=true&lang=pug&", function () {
      api.rerender('c1677c36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form_element/color.vue"
export default component.exports